<div [@routerTransition]>
  <div class="card my-profile-form margin-top-15px top-link" *ngIf="ShowList">
    <div class="card-header wh-header padding-bottom-6px">
      <div class="row">
        <div class="col-md-4">
          Vendors
        </div>
        <div class="col-md-8 padding-right-0px">
          <div class="row">
            <div class="offset-md-6 col-md-2 padding-right-0px text-align-right">
              <a (click)="AddNewVendor()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Vendor Registration"><i class="fas fa-plus font-size-11 margin-right-3px"></i>New</a>
            </div>
            <div class="col-md-4 float-right padding-right-0px padding-l-0px display-inherit">
              <form novalidate="" #f="ngForm" class="display-inherit">
                <div class="clear-form">
                  <input type="text" class="form-control" placeholder="Search" name="searchBar" maxlength="15">
                  <!--<a class="nav-link-hand" title="Clear"><span class="clear-icon"><i class="fa fa-times"></i></span></a>-->
                </div>
                <button class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-5px">Go</button>
              </form>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="card-body padding-top-0px">

      <div class="row">
        <div class="col-md-12">
          <div class="table-component">
            <div class="table-responsive overflow-x">


              <table class="table table-striped margin-left-zero"
                     cols="auto,2*,*,*,*,*,*,*">

                <thead class="">
                  <tr>

                    <th class="">
                      VID
                    </th>

                    <th class="">
                      Name
                    </th>
                    <th class="">
                      Short Name
                    </th>

                    <th class="">
                      Phone
                    </th>
                    <th class="">
                      Mobile
                    </th>
                    <th class="">
                      Location
                    </th>
                    <th>

                    </th>

                  </tr>
                </thead>

                <tbody class="table-body">
                  <tr>

                    <td class="td-padding-tb"><a class="nav-link-hand"><i class="far fa-folder-open margin-right-3px folder-color"></i>GG1/2432</a></td>
                    <td class=" td-padding-tb">Srinivas Enterprises</td>
                    <td class=" td-padding-tb">Srinivas Enterprises</td>
                    <td class="td-padding-tb">8801667136</td>
                    <td class="td-padding-tb ">8801224562</td>
                    <td class="td-padding-tb ">Hyd</td>
                    <td class=" td-padding-tb ">
                      <div class="test-icons">
                        <a (click)="EditVend()" class="font-size-16px padding-right-15px color-Assign" title="Edit"><i class="fas fa-pencil-alt margin-left-10px margin-bottom-3px nav-link-hand"></i></a>
                        <a class="nav-link-hand font-size-20px margin-left-15px" title="Remove"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>
                      </div>
                    </td>
                  </tr>

                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card my-profile-form margin-top-15px top-link" *ngIf="AddVendor">
    <div class="card-header wh-header padding-bottom-6px">
      <div class="col-md-12">
        <div class="row">
          <a class="nav-link-hand  back-link left-arrow-treatmentcycle2 margin-right-5px" (click)="Cancel()" title="Back To Vendor List"><i class="fas fa-angle-double-left font-size-19px"></i></a>
          Add New Vendor
        </div>
      </div>

    </div>
    <div class="card-body padding-top-0px">

      <div>
        <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
          <div class="accordion" id="accordionExample">
            <div class="card margin-bottom-5px">
              <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne">
                <div class="row">
                  <div class="col-md-4">
                    <h5 class="mb-0 height-24px">
                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        Registration
                      </button>
                    </h5>
                  </div>
                  <div class="col-md-2">
                    <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                    <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                  </div>
                </div>


              </div>

              <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Name</label>
                        </div>


                        <div class="col-md-3">

                          <input type="text" class="form-control" placeholder="Name"
                                 id="CurrentSaveVendorInformationRequest.DisplayName"
                                 [(ngModel)]="CurrentSaveVendorInformationRequest.DisplayName"
                                 name="CurrentSaveVendorInformationRequest.DisplayName" pattern="^[\sa-zA-Z0-9,._''\-?]*$"
                                 maxlength="100" />

                        </div>

                      </div>


                    </div>
                  </div>

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Short Name</label>
                        </div>


                        <div class="col-md-3">

                          <input type="text" class="form-control" placeholder="Short Name"
                                 id="CurrentSaveVendorInformationRequest.VendorShortName"
                                 [(ngModel)]="CurrentSaveVendorInformationRequest.VendorShortName"
                                 name="CurrentSaveVendorInformationRequest.VendorShortName" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                 maxlength="100" />

                        </div>

                      </div>


                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div>
        <form class="form " novalidate="" (ngSubmit)="onSubmit2()" #f="ngForm">
          <div class="accordion" id="accordionExample3">
            <div class="card margin-bottom-5px">
              <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne3">
                <div class="row">
                  <div class="col-md-4">
                    <h5 class="mb-0 height-24px">
                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne3" aria-expanded="true" aria-controls="collapseOne3">
                        Contact Address
                      </button>
                    </h5>
                  </div>
                  <div class="col-md-2">
                    <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                    <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                  </div>
                </div>


              </div>

              <div id="collapseOne3" class="collapse show" aria-labelledby="headingOne3" data-parent="#accordionExample3">
                <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Line 1</label>
                        </div>


                        <div class="col-md-3">

                          <!--<input type="text" class="form-control" placeholder="Line 1"
                                 pattern="^[\0-9,._\-?]*$">-->

                          <input type="text" class="form-control" placeholder="Address Line1"
                                 id="CurrentSaveVendorInformationRequest.AddressLine1"
                                 [(ngModel)]="CurrentSaveVendorInformationRequest.AddressLine1"
                                 name="CurrentSaveVendorInformationRequest.AddressLine1" pattern="^[\sa-zA-Z0-9,._''\-?]*$"
                                 maxlength="100" />

                        </div>
                      </div>


                    </div>
                  </div>
                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Line 2</label>
                        </div>


                        <div class="col-md-3">

                          <!--<input type="text" class="form-control" placeholder="Line 2"
                                 pattern="^[\0-9,._\-?]*$">-->

                          <input type="text" class="form-control" placeholder="Address Line2"
                                 id="CurrentSaveVendorInformationRequest.AddressLine2"
                                 [(ngModel)]="CurrentSaveVendorInformationRequest.AddressLine2"
                                 name="CurrentSaveVendorInformationRequest.AddressLine2" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                 maxlength="100" />

                        </div>

                      </div>


                    </div>
                  </div>

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Country</label>
                        </div>


                        <div class="col-md-3">

                          <!--<CodeTypeValue CodeType="CNTR"></CodeTypeValue>-->

                          <CodeTypeValue CodeType="CNTR"
                                         id="CurrentSaveVendorInformationRequest.Country" PassType="Long"
                                         [(ngModel)]="CurrentSaveVendorInformationRequest.Country" SelectedValue="{{CurrentSaveVendorInformationRequest.Country}}"
                                         name="CurrentSaveVendorInformationRequest.Country" #CNTR="ngModel">
                          </CodeTypeValue>

                        </div>

                      </div>


                    </div>
                  </div>

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">State</label>
                        </div>


                        <div class="col-md-3">

                          <!--<CodeTypeValue CodeType="State"></CodeTypeValue>-->

                          <CodeTypeValue CodeType="State"
                                         id="CurrentSaveVendorInformationRequest.State" PassType="Long"
                                         [(ngModel)]="CurrentSaveVendorInformationRequest.State" SelectedValue="{{CurrentSaveVendorInformationRequest.State}}"
                                         name="CurrentSaveVendorInformationRequest.State" #State="ngModel">
                          </CodeTypeValue>

                        </div>

                      </div>


                    </div>
                  </div>

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">City</label>
                        </div>


                        <div class="col-md-3">

                          <!--<CodeTypeValue CodeType="City"></CodeTypeValue>-->

                          <CodeTypeValue CodeType="City"
                                         id="CurrentSaveVendorInformationRequest.City" PassType="Long"
                                         [(ngModel)]="CurrentSaveVendorInformationRequest.City" SelectedValue="{{CurrentSaveVendorInformationRequest.City}}"
                                         name="CurrentSaveVendorInformationRequest.City" #City="ngModel">
                          </CodeTypeValue>

                        </div>

                      </div>


                    </div>
                  </div>

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Zip Code</label>
                        </div>


                        <div class="col-md-3">

                          <!--<input type="text" class="form-control" placeholder="Zip Code"
                                 pattern="^[\0-9,._\-?]*$">-->

                          <input type="text" class="form-control" placeholder="Zip Code"
                                 id="CurrentSaveVendorInformationRequest.Zip"
                                 [(ngModel)]="CurrentSaveVendorInformationRequest.Zip"
                                 name="CurrentSaveVendorInformationRequest.Zip"
                                 maxlength="6" pattern="[0-9]{6}">

                        </div>

                      </div>


                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div>
        <form class="form " novalidate="" (ngSubmit)="onSubmit3()" #f="ngForm">
          <div class="accordion" id="accordionExample4">
            <div class="card margin-bottom-5px">
              <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne4">
                <div class="row">
                  <div class="col-md-4">
                    <h5 class="mb-0 height-24px">
                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne4" aria-expanded="true" aria-controls="collapseOne4">
                        Contact Details
                      </button>
                    </h5>
                  </div>
                  <div class="col-md-2">
                    <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                    <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                  </div>
                </div>


              </div>

              <div id="collapseOne4" class="collapse show" aria-labelledby="headingOne4" data-parent="#accordionExample4">
                <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Mobile Phone</label>
                        </div>


                        <div class="col-md-3">

                          <!--<input type="tel" class="form-control" placeholder="Mobile Phone"
                                 mask="(000) 000-0000" pattern="[0-9]{10}">-->

                          <input type="tel" class="form-control" placeholder="Mobile Phone"
                                 id="CurrentSaveVendorInformationRequest.Telephone1"
                                 [(ngModel)]="CurrentSaveVendorInformationRequest.Telephone1"
                                 name="CurrentSaveVendorInformationRequest.Telephone1"
                                 mask="(000) 000-0000" pattern="[0-9]{10}">

                        </div>
                      </div>


                    </div>
                  </div>
                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Email Address</label>
                        </div>


                        <div class="col-md-3">

                          <!--<input type="email" class="form-control" placeholder="Email Address"
                                 pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$">-->

                          <input type="email" class="form-control" placeholder="Email Address"
                                 id="CurrentSaveVendorInformationRequest.Email"
                                 [(ngModel)]="CurrentSaveVendorInformationRequest.Email"
                                 name="CurrentSaveVendorInformationRequest.Email"
                                 pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$">

                        </div>

                      </div>


                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div>
        <form class="form " novalidate="" #f="ngForm">
          <div class="accordion" id="accordionExample5">
            <div class="card margin-bottom-5px">
              <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne5">
                <div class="row">
                  <div class="col-md-7">
                    <h5 class="mb-0 height-24px">
                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne5" aria-expanded="true" aria-controls="collapseOne5">
                        Credentials
                      </button>
                    </h5>
                  </div>
                  <div class="col-md-2 padding-right-0px text-align-right">
                    <a (click)="AddNewCredential()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Credential"><i class="fas fa-plus font-size-11 margin-right-3px"></i>New</a>
                  </div>
                  <div class="col-md-1">
                    <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                    <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                  </div>
                </div>


              </div>

              <div id="collapseOne5" class="collapse show" aria-labelledby="headingOne5" data-parent="#accordionExample5">
                <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                  <div class="row my-profile-form">
                    <div class="col-md-10 padding-right-0px">
                      <div class="table-component margin-bottom-0px">
                        <div class="table-responsive overflow-x">


                          <table class="table table-striped margin-left-zero width-100pe"
                                 cols="auto,2*,*,*,*,*,*,*">

                            <thead class="">
                              <tr>

                                <th class="">
                                  Name
                                </th>

                                <th class="">
                                  NO
                                </th>
                                <th class="">
                                  Issuing Authority
                                </th>

                                <th class="">
                                  Valid From
                                </th>
                                <th class="">
                                  Valid To
                                </th>

                                <th class="">
                                  Additional Info
                                </th>

                                <th class="">
                                  Remarks
                                </th>

                                <th class="">

                                </th>

                              </tr>
                            </thead>

                            <tbody class="table-body">
                              <tr>

                                <td class="td-padding-tb">CPR</td>
                                <td class=" td-padding-tb">AB4582</td>
                                <td class=" td-padding-tb">ACS</td>
                                <td class="td-padding-tb">10-08-2017</td>
                                <td class="td-padding-tb ">15-06-2022</td>
                                <td class="td-padding-tb ">Add info</td>
                                <td class="td-padding-tb ">abc</td>
                                <td class=" td-padding-tb ">
                                  <div class="test-icons">
                                    <a (click)="EditNewCredential()" class="font-size-16px color-Assign" title="Edit"><i class="fas fa-pencil-alt margin-left-10px margin-bottom-3px nav-link-hand"></i></a>
                                    <a class="nav-link-hand font-size-20px margin-left-15px" title="Remove"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>
                                  </div>
                                </td>
                              </tr>

                            </tbody>

                          </table>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div>
        <form class="form " novalidate="" #f="ngForm">
          <div class="accordion" id="accordionExample6">
            <div class="card margin-bottom-5px">
              <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne6">
                <div class="row">
                  <div class="col-md-7">
                    <h5 class="mb-0 height-24px">
                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne6" aria-expanded="true" aria-controls="collapseOne6">
                        Supplier Materials
                      </button>
                    </h5>
                  </div>
                  <div class="col-md-2 padding-right-0px text-align-right">
                    <a (click)="AddNewsuplMaterials()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New SupMaterials"><i class="fas fa-plus font-size-11 margin-right-3px"></i>New</a>
                  </div>
                  <div class="col-md-1">
                    <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                    <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                  </div>
                </div>


              </div>

              <div id="collapseOne6" class="collapse show" aria-labelledby="headingOne6" data-parent="#accordionExample6">
                <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                  <div class="row my-profile-form">
                    <div class="col-md-10 padding-right-0px">
                      <div class="table-component margin-bottom-0px">
                        <div class="table-responsive overflow-x">


                          <table class="table table-striped margin-left-zero width-100pe"
                                 cols="auto,2*,*,*,*,*,*,*">

                            <thead class="">
                              <tr>

                                <th class="">
                                  Specification Details
                                </th>

                                <th class="">
                                  Min Ord Qty
                                </th>
                                <th class="">
                                  Max Ord Qty
                                </th>

                                <th class="">
                                  Lead Time(days)
                                </th>
                                <th class="">
                                  Has Rate Contract
                                </th>

                                <th class="">

                                </th>

                              </tr>
                            </thead>

                            <tbody class="table-body">
                              <tr>

                                <td class="td-padding-tb">EEMA HP 5000 IU</td>
                                <td class=" td-padding-tb">1</td>
                                <td class=" td-padding-tb">20</td>
                                <td class="td-padding-tb">10</td>
                                <td class="td-padding-tb ">
                                  <input type="checkbox" class="width-15px">
                                </td>
                                <td class=" td-padding-tb ">
                                  <div class="test-icons">
                                    <a (click)="EditNewsuplMaterials()" class="font-size-16px color-Assign" title="Edit"><i class="fas fa-pencil-alt margin-left-10px margin-bottom-3px nav-link-hand"></i></a>
                                    <a class="nav-link-hand font-size-20px margin-left-15px" title="Remove"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>
                                  </div>
                                </td>
                              </tr>

                            </tbody>

                          </table>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

    </div>
  </div>

  <div class="card my-profile-form margin-top-15px top-link" *ngIf="EditVendor">
    <div class="card-header wh-header padding-bottom-6px">
      <div class="col-md-12">
        <div class="row">
          <a class="nav-link-hand  back-link left-arrow-treatmentcycle2 margin-right-5px" (click)="Cancel()" title="Back To Vendor List"><i class="fas fa-angle-double-left font-size-19px"></i></a>
          Edit Vendor
        </div>
      </div>

    </div>
    <div class="card-body padding-top-0px">

      <div>
        <form class="form " novalidate="" #f="ngForm">
          <div class="accordion" id="accordionExample">
            <div class="card margin-bottom-5px">
              <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne">
                <div class="row">
                  <div class="col-md-4">
                    <h5 class="mb-0 height-24px">
                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        Registration
                      </button>
                    </h5>
                  </div>
                  <div class="col-md-2">
                    <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                    <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                  </div>
                </div>


              </div>

              <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Name</label>
                        </div>


                        <div class="col-md-3">

                          <input type="text" class="form-control" placeholder="Name"
                                 pattern="^[\0-9,._\-?]*$">

                        </div>

                      </div>


                    </div>
                  </div>

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Short Name</label>
                        </div>


                        <div class="col-md-3">

                          <input type="text" class="form-control" placeholder="Short Name"
                                 pattern="^[\0-9,._\-?]*$">

                        </div>

                      </div>


                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div>
        <form class="form " novalidate="" #f="ngForm">
          <div class="accordion" id="accordionExample3">
            <div class="card margin-bottom-5px">
              <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne3">
                <div class="row">
                  <div class="col-md-4">
                    <h5 class="mb-0 height-24px">
                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne3" aria-expanded="true" aria-controls="collapseOne3">
                        Contact Address
                      </button>
                    </h5>
                  </div>
                  <div class="col-md-2">
                    <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                    <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                  </div>
                </div>


              </div>

              <div id="collapseOne3" class="collapse show" aria-labelledby="headingOne3" data-parent="#accordionExample3">
                <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Line 1</label>
                        </div>


                        <div class="col-md-3">

                          <input type="text" class="form-control" placeholder="Line 1"
                                 pattern="^[\0-9,._\-?]*$">

                        </div>
                      </div>


                    </div>
                  </div>
                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Line 2</label>
                        </div>


                        <div class="col-md-3">

                          <input type="text" class="form-control" placeholder="Line 2"
                                 pattern="^[\0-9,._\-?]*$">

                        </div>

                      </div>


                    </div>
                  </div>

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Country</label>
                        </div>


                        <div class="col-md-3">

                          <CodeTypeValue CodeType="CNTR"></CodeTypeValue>

                        </div>

                      </div>


                    </div>
                  </div>

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">State</label>
                        </div>


                        <div class="col-md-3">

                          <CodeTypeValue CodeType="State"></CodeTypeValue>

                        </div>

                      </div>


                    </div>
                  </div>

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">City</label>
                        </div>


                        <div class="col-md-3">

                          <CodeTypeValue CodeType="City"></CodeTypeValue>

                        </div>

                      </div>


                    </div>
                  </div>

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Zip Code</label>
                        </div>


                        <div class="col-md-3">

                          <input type="text" class="form-control" placeholder="Zip Code"
                                 pattern="^[\0-9,._\-?]*$">

                        </div>

                      </div>


                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div>
        <form class="form " novalidate="" #f="ngForm">
          <div class="accordion" id="accordionExample4">
            <div class="card margin-bottom-5px">
              <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne4">
                <div class="row">
                  <div class="col-md-4">
                    <h5 class="mb-0 height-24px">
                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne4" aria-expanded="true" aria-controls="collapseOne4">
                        Contact Details
                      </button>
                    </h5>
                  </div>
                  <div class="col-md-2">
                    <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                    <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                  </div>
                </div>


              </div>

              <div id="collapseOne4" class="collapse show" aria-labelledby="headingOne4" data-parent="#accordionExample4">
                <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Mobile Phone</label>
                        </div>


                        <div class="col-md-3">

                          <input type="tel" class="form-control" placeholder="Mobile Phone"
                                 mask="(000) 000-0000" pattern="[0-9]{10}">

                        </div>
                      </div>


                    </div>
                  </div>
                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Email Address</label>
                        </div>


                        <div class="col-md-3">

                          <input type="email" class="form-control" placeholder="Email Address"
                                 pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$">

                        </div>

                      </div>


                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div>
        <form class="form " novalidate="" #f="ngForm">
          <div class="accordion" id="accordionExample5">
            <div class="card margin-bottom-5px">
              <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne5">
                <div class="row">
                  <div class="col-md-7">
                    <h5 class="mb-0 height-24px">
                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne5" aria-expanded="true" aria-controls="collapseOne5">
                        Credentials
                      </button>
                    </h5>
                  </div>
                  <div class="col-md-2 padding-right-0px text-align-right">
                    <a (click)="AddNewCredential()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Credential"><i class="fas fa-plus font-size-11 margin-right-3px"></i>New</a>
                  </div>
                  <div class="col-md-1">
                    <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                    <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                  </div>
                </div>


              </div>

              <div id="collapseOne5" class="collapse show" aria-labelledby="headingOne5" data-parent="#accordionExample5">
                <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                  <div class="row my-profile-form">
                    <div class="col-md-10 padding-right-0px">
                      <div class="table-component margin-bottom-0px">
                        <div class="table-responsive overflow-x">


                          <table class="table table-striped margin-left-zero width-100pe"
                                 cols="auto,2*,*,*,*,*,*,*">

                            <thead class="">
                              <tr>

                                <th class="">
                                  Name
                                </th>

                                <th class="">
                                  NO
                                </th>
                                <th class="">
                                  Issuing Authority
                                </th>

                                <th class="">
                                  Valid From
                                </th>
                                <th class="">
                                  Valid To
                                </th>

                                <th class="">
                                  Additional Info
                                </th>

                                <th class="">
                                  Remarks
                                </th>

                                <th class="">

                                </th>

                              </tr>
                            </thead>

                            <tbody class="table-body">
                              <tr>

                                <td class="td-padding-tb">CPR</td>
                                <td class=" td-padding-tb">AB4582</td>
                                <td class=" td-padding-tb">ACS</td>
                                <td class="td-padding-tb">10-08-2017</td>
                                <td class="td-padding-tb ">15-06-2022</td>
                                <td class="td-padding-tb ">Add info</td>
                                <td class="td-padding-tb ">abc</td>
                                <td class=" td-padding-tb ">
                                  <div class="test-icons">
                                    <a (click)="EditNewCredential()" class="font-size-16px color-Assign" title="Edit"><i class="fas fa-pencil-alt margin-left-10px margin-bottom-3px nav-link-hand"></i></a>
                                    <a class="nav-link-hand font-size-20px margin-left-15px" title="Remove"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>
                                  </div>
                                </td>
                              </tr>

                            </tbody>

                          </table>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div>
        <form class="form " novalidate="" #f="ngForm">
          <div class="accordion" id="accordionExample6">
            <div class="card margin-bottom-5px">
              <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne6">
                <div class="row">
                  <div class="col-md-7">
                    <h5 class="mb-0 height-24px">
                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne6" aria-expanded="true" aria-controls="collapseOne6">
                        Supplier Materials
                      </button>
                    </h5>
                  </div>
                  <div class="col-md-2 padding-right-0px text-align-right">
                    <a (click)="AddNewsuplMaterials()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New SupMaterials"><i class="fas fa-plus font-size-11 margin-right-3px"></i>New</a>
                  </div>
                  <div class="col-md-1">
                    <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                    <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                  </div>
                </div>


              </div>

              <div id="collapseOne6" class="collapse show" aria-labelledby="headingOne6" data-parent="#accordionExample6">
                <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                  <div class="row my-profile-form">
                    <div class="col-md-10 padding-right-0px">
                      <div class="table-component margin-bottom-0px">
                        <div class="table-responsive overflow-x">


                          <table class="table table-striped margin-left-zero width-100pe"
                                 cols="auto,2*,*,*,*,*,*,*">

                            <thead class="">
                              <tr>

                                <th class="">
                                  Specification Details
                                </th>

                                <th class="">
                                  Min Ord Qty
                                </th>
                                <th class="">
                                  Max Ord Qty
                                </th>

                                <th class="">
                                  Lead Time(days)
                                </th>
                                <th class="">
                                  Has Rate Contract
                                </th>

                                <th class="">

                                </th>

                              </tr>
                            </thead>

                            <tbody class="table-body">
                              <tr>

                                <td class="td-padding-tb">EEMA HP 5000 IU</td>
                                <td class=" td-padding-tb">1</td>
                                <td class=" td-padding-tb">20</td>
                                <td class="td-padding-tb">10</td>
                                <td class="td-padding-tb ">
                                  <input type="checkbox" class="width-15px">
                                </td>
                                <td class=" td-padding-tb ">
                                  <div class="test-icons">
                                    <a (click)="EditNewsuplMaterials()" class="font-size-16px color-Assign" title="Edit"><i class="fas fa-pencil-alt margin-left-10px margin-bottom-3px nav-link-hand"></i></a>
                                    <a class="nav-link-hand font-size-20px margin-left-15px" title="Remove"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>
                                  </div>
                                </td>
                              </tr>

                            </tbody>

                          </table>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

    </div>
  </div>

</div>
